import ReservedCollectionsTable, {
  ReservedCollectionsTableItem
} from './ReservedCollectionsTable.vue'

export { ReservedCollectionsTable, ReservedCollectionsTableItem }
